/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const pieChart = function (id, title, data, units, legend) {
  let chart
  if (units === undefined) {
    units = "times"
  }
  if (legend === undefined) {
    legend = false
  }
  return (chart = new Highcharts.Chart({
    chart: {
      renderTo: id,
      height: 250,
      spacingBottom: 5,
      spacingTop: 5,
      spacingLeft: 5,
      spacingRight: 5,
    },
    credits: {
      enabled: false,
    },
    title: {
      y: 5,
      text: title,
      floating: true,
      style: {
        color: "#333333",
        fontSize: "12px",
      },
    },
    legend: {
      layout: "vertical",
      align: "right",
    },
    tooltip: {
      enabled: false,
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
      formatter() {
        return (
          "<b>" +
          this.point.name +
          "</b>: " +
          this.y +
          " " +
          units +
          " (" +
          Highcharts.numberFormat(this.percentage, 1) +
          "%)"
        )
      },
    },
    plotOptions: {
      pie: {
        size: "47%",
        dataLabels: {
          enabled: true,
          color: "#333333",
          connectorColor: "#666666",
          distance: 20,
          useHTML: true,
          softConnector: false,
          x: 0,
          y: -9,
          format:
            '<div class="label-percentage">{point.percentage:.2f}%<div><div class="label-name">{point.name}</div>',
        },
        allowPointSelect: true,
        showInLegend: legend,
        cursor: "pointer",
        startAngle: 45,
      },
    },
    series: [
      {
        type: "pie",
        name: title,
        data,
      },
    ],
  }))
}

const sparklineGraph = function (
  id,
  title,
  data,
  start_date,
  mode,
  y_axis_text,
  plot_band_date
) {
  let chart
  if (y_axis_text === "undefined") {
    y_axis_text = null
  }
  if (plot_band_date === "undefined") {
    plot_band_date = null
  }

  return (chart = new Highcharts.Chart({
    chart: {
      renderTo: id,
      defaultSeriesType: "line",
      height: 140,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: null,
    },
    subtitle: {
      text: null,
    },
    tooltip: {
      formatter() {
        const dateText = (() => {
          switch (mode) {
            case "day":
              return Highcharts.dateFormat("%a, %e %b", this.x)
            case "week":
              return (
                Highcharts.dateFormat(
                  "%a, %e %b",
                  Math.max(this.x, start_date)
                ) +
                " - " +
                Highcharts.dateFormat(
                  "%a, %e %b",
                  this.x + 6 * 24 * 3600 * 1000
                )
              )
            case "month":
              return (
                Highcharts.dateFormat(
                  "%a, %e %b",
                  Math.max(this.x, start_date)
                ) +
                " - " +
                Highcharts.dateFormat(
                  "%a, %e %b",
                  moment(this.x).endOf("month").utc()
                )
              )
          }
        })()
        return dateText + "<br/>" + this.series.name + ": <b>" + this.y + "</b>"
      },
    },
    xAxis: {
      type: "datetime",
      dateTimeLabelFormats: {
        day: "%b %e",
        week: "%b %e",
      },
      title: {
        text: null,
      },
      labels: {
        enabled: true,
        style: {
          color: "#7d7d7d",
          fontWeight: "normal",
        },
      },
      lineWidth: 1,
      tickLength: 5,
      minPadding: 0.05,
      plotBands: {
        color: "#fff6f6",
        from: 0,
        to: plot_band_date,
        label: {
          text: plot_band_date ? "Estimated Data" : undefined,
          style: {
            fontSize: "9px",
            color: "#ff6666",
          },
          align: "right",
          x: -10,
        },
      },
    },
    yAxis: {
      title: {
        text: y_axis_text,
        margin: 20,
        style: {
          color: "#7d7d7d",
          fontWeight: "normal",
          fontSize: "10px",
        },
      },
      labels: {
        style: {
          color: "#7d7d7d",
          fontWeight: "normal",
        },
      },
      gridLineWidth: 1,
      gridLineColor: "#eee",
      lineWidth: 1,
      tickLength: 5,
      min: 0,
    },
    plotOptions: {
      line: {
        lineWidth: 1,
        shadow: false,
        marker: {
          enabled: false,
        },
        states: {
          hover: {
            linewidth: 1,
          },
        },
      },
    },
    series: [
      {
        name: title,
        data,
      },
    ],
    legend: {
      enabled: false,
    },

    colors: ["#0077cc"],
  }))
}

const lineGraph = function (
  id,
  title,
  multi_data,
  start_date,
  mode,
  y_axis_text
) {
  let chart
  if (y_axis_text === "undefined") {
    y_axis_text = null
  }

  return (chart = new Highcharts.Chart({
    chart: {
      renderTo: id,
      defaultSeriesType: "line",
      height: 250,
      zoomType: "x",
      spacingRight: 20,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: null,
    },
    subtitle: {
      text: null,
    },
    tooltip: {
      formatter() {
        const dateText = (() => {
          switch (mode) {
            case "day":
              return Highcharts.dateFormat("%a, %e %b", this.x)
            case "week":
              return (
                Highcharts.dateFormat(
                  "%a, %e %b",
                  Math.max(this.x, start_date)
                ) +
                " - " +
                Highcharts.dateFormat(
                  "%a, %e %b",
                  this.x + 6 * 24 * 3600 * 1000
                )
              )
            case "month":
              return (
                Highcharts.dateFormat(
                  "%a, %e %b",
                  Math.max(this.x, start_date)
                ) +
                " - " +
                Highcharts.dateFormat(
                  "%a, %e %b",
                  moment(this.x).endOf("month").utc()
                )
              )
          }
        })()
        return dateText + "<br/>" + this.series.name + ": <b>" + this.y + "</b>"
      },
    },
    legend: {
      borderWidth: 0,
    },
    xAxis: {
      type: "datetime",
      dateTimeLabelFormats: {
        day: "%b %e",
        week: "%b %e",
      },
      title: {
        text: null,
      },
      labels: {
        enabled: true,
        style: {
          color: "#7d7d7d",
          fontWeight: "normal",
        },
      },
      gridLineWidth: 0,
      lineWidth: 1,
      tickLength: 5,
      minPadding: 0.05,
      showLastLabel: true,
      maxZoom: 14 * 24 * 3600000,
    }, // fourteen days
    yAxis: {
      title: {
        text: y_axis_text,
        margin: 20,
        style: {
          color: "#7d7d7d",
          fontWeight: "normal",
          fontSize: "10px",
        },
      },
      labels: {
        style: {
          color: "#7d7d7d",
          fontWeight: "normal",
        },
      },
      gridLineWidth: 1,
      gridLineColor: "#eee",
      lineWidth: 1,
      tickLength: 5,
      min: 0,
      minTickInterval: 1,
    },
    plotOptions: {
      line: {
        lineWidth: 1,
        shadow: false,
        marker: {
          enabled: false,
        },
        states: {
          hover: {
            linewidth: 1,
          },
        },
      },
    },
    series: multi_data,
  }))
}

this.loadCharts = function () {
  $(".sparkline-chart").each(function () {
    const chart = $(this)

    return $.ajax({
      url: chart.data("chart-url"),
      type: "GET",
      async: true,
      dataType: "json",
      success(data) {
        let filter, total_html
        sparklineGraph(
          chart.attr("id"),
          chart.data("title"),
          data.data,
          chart.data("start-date"),
          chart.data("mode"),
          chart.data("y-axis-text"),
          chart.data("estimated-data-date")
        )
        const total = addCommas(data.total)
        if (chart.data("link") !== "") {
          total_html = '<a href="' + chart.data("link") + '">' + total + "</a>"
        } else {
          total_html = total
        }

        if (chart.data("filter") === undefined) {
          filter = ""
        } else {
          filter = chart.data("filter")
        }

        $("#total_" + chart.data("chart-type") + "_" + filter).html(total_html)
      },
    })
  })

  $(".line-chart").each(function () {
    const chart = $(this)
    return lineGraph(
      this.id,
      chart.data("title"),
      chart.data("chart"),
      chart.data("start-date"),
      chart.data("mode"),
      chart.data("y-axis-text")
    )
  })

  return $(".pie-chart").each(function () {
    const chart = $(this)
    return pieChart(this.id, chart.data("title"), chart.data("chart"))
  }) //,
}
// chart.data('start-date')

global.loadCharts = this.loadCharts
